import { render, staticRenderFns } from "./migration.vue?vue&type=template&id=5767a67f&scoped=true&lang=html&"
import script from "./migration.vue?vue&type=script&lang=js&"
export * from "./migration.vue?vue&type=script&lang=js&"
import style0 from "./migration.vue?vue&type=style&index=0&id=5767a67f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5767a67f",
  null
  
)

component.options.__file = "migration.vue"
export default component.exports